import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const LinkIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M15 2C14.4477 2 14 2.44772 14 3C14 3.55229 14.4477 4 15 4L18.5858 4L10.2929 12.2929C9.90237 12.6834 9.90237 13.3166 10.2929 13.7071C10.6834 14.0976 11.3166 14.0976 11.7071 13.7071L20 5.41422L20 9C20 9.55229 20.4477 10 21 10C21.5523 10 22 9.55229 22 9L22 3C22 2.44772 21.5523 2 21 2L15 2ZM5 4C3.34315 4 2 5.34314 2 7L2 19C2 20.6569 3.34314 22 5 22L17 22C18.6569 22 20 20.6569 20 19L20 13C20 12.4477 19.5523 12 19 12C18.4477 12 18 12.4477 18 13L18 19C18 19.5523 17.5523 20 17 20L5 20C4.44771 20 4 19.5523 4 19L4 7C4 6.44772 4.44772 6 5 6L11 6C11.5523 6 12 5.55229 12 5C12 4.44772 11.5523 4 11 4L5 4Z"
    fill="currentColor"
  />,
  "LinkIcon"
);
